import { makeIcon } from "components/ui/Icon";

export const LessThanOperatorIcon = makeIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <rect fill="var(--foreground)" height="24" rx="4" width="24" />
    <path d="M14.4926 20L6 12L14.4926 4L16 5.42L9.01486 12L16 18.58L14.4926 20Z" fill="var(--background)" />
  </svg>,
);
